import { CommunityWin } from '@platform/client/schemas';

type CommunityWinsCarouselContentProps = {
  communityWin: CommunityWin;
};

export const CommunityWinsCarouselContent = (props: CommunityWinsCarouselContentProps) => {
  const { communityWin } = { ...props };
  return (
    <div className='w-full md:max-w-[340px] md:max-h-[230px] min-h-[50px] flex flex-col gap-4'>
      <div className='text-md md:text-xl text-center md:line-clamp-6'>
        {communityWin.description}
      </div>
    </div>
  );
};
